export default {
   setAccounts: (state,payload) => {
    state.accounts = payload;
   }
}